__webpack_require__.p = "https://uk.knowledgesearchadmin.thomsonreuters.com/";